import { Apple, Play } from "lucide-react";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/lib/config";
import { trackEvent } from "@/lib/analytics";

function BadgeLink({ href, eyebrow, storeName, Icon, testId, placement }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="yn-badge"
      data-testid={testId}
      onClick={() =>
        trackEvent("store_badge_click", {
          store: storeName,
          placement,
        })
      }
      aria-label={`${eyebrow} ${storeName}`}
    >
      <Icon size={26} strokeWidth={1.5} aria-hidden="true" />
      <span className="yn-badge__label">
        <span className="yn-badge__eyebrow">{eyebrow}</span>
        <span className="yn-badge__store">{storeName}</span>
      </span>
    </a>
  );
}

export default function StoreBadges({
  placement = "unknown",
  className = "",
  appTestId,
  playTestId,
  size = "default",
}) {
  return (
    <div
      className={`flex flex-wrap items-center gap-3 sm:gap-4 ${
        size === "lg" ? "" : ""
      } ${className}`}
    >
      <BadgeLink
        href={APP_STORE_URL}
        eyebrow="Download on the"
        storeName="App Store"
        Icon={Apple}
        testId={appTestId}
        placement={placement}
      />
      <BadgeLink
        href={PLAY_STORE_URL}
        eyebrow="Get it on"
        storeName="Google Play"
        Icon={Play}
        testId={playTestId}
        placement={placement}
      />
    </div>
  );
}
